import './css/styles.scss';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function mobileNavInit() {
	const menuToggle = document.querySelector('[data-open-menu]');
	if (!menuToggle) return;

	const target = document.querySelector(`.jaktia-main-nav`);
	if (!target) return;

	const closeBtn = target.querySelector('[data-menu-close]');
	if (!closeBtn) return;

	const bodyOverlay = document.querySelector('[data-menu-overlay]');

	menuToggle.addEventListener('click', () => {
		target.classList.toggle('is-open');
		menuToggle.classList.toggle('is-open');
		disableBodyScroll(target);
		if (bodyOverlay) {
			bodyOverlay.classList.toggle('-active');
		}
	});

	closeBtn.addEventListener('click', () => {
		target.classList.toggle('is-open');
		menuToggle.classList.toggle('is-open');
		enableBodyScroll(target);
		if (bodyOverlay) {
			bodyOverlay.classList.toggle('-active');
		}
	});

	if (bodyOverlay) {
		bodyOverlay.addEventListener('click', () => {
			target.classList.toggle('is-open');
			menuToggle.classList.toggle('is-open');
			bodyOverlay.classList.toggle('-active');
		});
	}
}

function initSubmenu() {
	const mobileNav = document.querySelector('.jaktia-main-nav');
	if (!mobileNav) return;

	const toggleBtns = mobileNav.querySelectorAll('.toggle-button');

	toggleBtns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();

			const toggleButton = e.currentTarget as HTMLElement;
			const parentItem = toggleButton.closest('li.menu-item');
			if (!parentItem) return;

			// Stäng andra på samma nivå om du vill ha accordioneffekt
			const siblings = parentItem.parentElement?.children;
			if (siblings) {
				Array.from(siblings).forEach((sibling) => {
					if (sibling !== parentItem) {
						(sibling as HTMLElement).classList.remove('active');
					}
				});
			}

			parentItem.classList.toggle('active');
			toggleButton.classList.toggle('rotated');
		});
	});
}


document.addEventListener('DOMContentLoaded', function () {
	mobileNavInit();
	initSubmenu();
});
